<div class="modal-header">
  <h3 class="modal-title">Tag {{ files.length }} {{ files.length === 1 ? 'file' : 'files' }}</h3>
  <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  @if (!tags && !error) {
    <p>Loading...</p>
  }
  @for (tag of tags; track tag.id) {
    <label class="d-block">
      <input type="checkbox" [checked]="checked.has(tag.id)" (change)="toggle(tag.id)">
      <i class="fas fa-tag ml-2 mr-1" [style.color]="tag.color"></i>{{ tag.name }}
    </label>
  } @empty {
    @if (tags) {
      <p>This project has no tags yet. Admins create them on the project's Tags page.</p>
    }
  }
  @if (error) {
    <div class="alert alert-danger">{{ error }}</div>
  }
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-outline-secondary" (click)="activeModal.dismiss()">Cancel</button>
  <button type="button" class="btn btn-primary" [disabled]="!tags?.length || saving" (click)="confirm()">Confirm</button>
</div>
